import lottie from "lottie-web"
import basicThankYouAnimation from "../../animations/thank-you-animation.json"
import upsell from "../upsell"
import { TrackingManager } from "../../../../../lib/common/js/services/tracking/trackingManager"
import { getFrontendCustomField } from "../../../../../lib/common/js/frontendCustomFields"
import { getLocalizedDateLabel, getNextPaymentDateAfterPurchase, getOfferMonths, getOfferWeeks } from "../../../../../lib/common/js/helpers"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell(),

  statusToTrack: "PURCHASE",
  isStoreDataChangedNeeded: true,
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),
  tyPageTrialVersion: getFrontendCustomField({
    pipelineConfig,
    fieldName: 'tyPageTrialVersion'
  }),

  init() {
    this.commonInit()

    setTimeout(() => {
      lottie.loadAnimation({
        container: document.querySelector("#thankyou-animation"),
        animationData: basicThankYouAnimation,
        renderer: "svg",
        loop: true,
        autoplay: true,
      })
    })
  },

  onInit() {
    this.store.savePurchasedBasicOffer()
  },

  redirectUserToNextPage() {
    window.location = nextStepPath
  },

  sendSentryError() {
    if (window && window.Sentry && window.Sentry.captureMessage) {
      try {
        window.Sentry.captureMessage("segmentUserId is not set")
      } catch (error) {
        console.error("Sentry error:", error)
      }
    } else {
      console.error("Window.Sentry is not available")
    }
  },

  handleButton() {
    if (!this.store.values.segmentUserId) {
      // Log error if segmentUserId is not set
      this.sendSentryError()
    }

    this.internalTracker.trackClick({ clickName: "Continue Clicked" })
    this.redirectUserToNextPage()
  },

  //
  // Pricing
  //

  getPaidPrice() {
    const isChance = this.store.values.trialExitIntent ? false : this.store.values.exitIntent

    return this.store.pricing.getPrice({
      offer: this.store.values.activeOffer,
      isChance: isChance,
    })
  },

  getFuturePrice() {
    const offer = this.store.values.activeOffer
    const isChance = this.store.values.exitIntent

    return this.store.pricing.getFuturePrice({
      offer,
      isChance
    })
  },

  getFuturePricePerPeriod() {
    const offer = this.store.values.activeOffer
    const isChance = this.store.values.exitIntent

    return this.store.pricing.getFuturePricePerPeriod({
      offer,
      isChance
    })
  },

  getNextPaymentDateAfterPurchase() {
    const futureDate = getNextPaymentDateAfterPurchase(this.store.values.activeOffer)

    return getLocalizedDateLabel(futureDate)
  },

  getPriceDiscount() {
    const offer = this.store.values.activeOffer
    const isChance = this.store.values.exitIntent

    return this.store.pricing.getPriceDiscount({
      offer,
      isChance
    })
  },

  isOfferTrial() {
    return this.store.pricing.isOfferTrial(this.store.values.activeOffer)
  },
  
  //
  
  getOfferMonths(offer = this.store.values.activeOffer) {
    return getOfferMonths(offer)
  },

  isOfferMultipleMonths(offer = this.store.values.activeOffer) {
    return getOfferMonths(offer) > 1
  },

  //
  
  getOfferWeeks(offer = this.store.values.activeOffer) {
    return getOfferWeeks(offer)
  },
  
  isOfferMultipleWeeks(offer = this.store.values.activeOffer) {
    return getOfferWeeks(offer) > 1
  },
})
